import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, HardHat, Briefcase, Home, HeartPulse, Landmark, UserCheck } from 'lucide-react';
const audiences = [{
  icon: HardHat,
  title: 'Trabajador accidentado',
  desc: 'Tuviste un accidente laboral y la ART no te da lo que corresponde o te apura para darte el alta.'
}, {
  icon: Briefcase,
  title: 'Empleado en conflicto',
  desc: 'Te despidieron, suspendieron o te están presionando para que renuncies. Necesitás saber qué podés hacer.'
}, {
  icon: Home,
  title: 'Inquilino bajo presión',
  desc: 'Tu propietario o inmobiliaria te cobra de más, no repara lo que le corresponde o te amenaza con el desalojo.'
}, {
  icon: HeartPulse,
  title: 'Afiliado con cobertura negada',
  desc: 'Tu obra social o prepaga te negó un medicamento, tratamiento o cirugía que te corresponde por ley.'
}, {
  icon: Landmark,
  title: 'Cliente bancario estafado',
  desc: 'El banco te cobró algo que no pediste, te aplicó comisiones ilegales o no da de baja un débito automático.',
  badge: 'MÁS FRECUENTE'
}, {
  icon: UserCheck,
  title: 'Cualquier ciudadano',
  desc: 'Sentís que el sistema juega en tu contra y no sabés por dónde empezar a defenderte.'
}];
export function ForWhom() {
  return <section className="py-12 md:py-[70px] px-5 bg-off-white" data-id="element-70">
      <div className="max-w-[860px] mx-auto" data-id="element-71">
        <div className="text-[11px] font-extrabold tracking-[0.14em] uppercase text-blue mb-2" data-id="element-72">
          ¿Para quién es?
        </div>
        <h2 className="font-display text-[clamp(28px,6vw,52px)] text-navy mb-2 leading-tight" data-id="element-73">
          Diseñado para vos si alguna institución te está haciendo la vida
          imposible
        </h2>
        <p className="text-[14px] md:text-[16px] text-text-muted max-w-[560px] mb-6 md:mb-10" data-id="element-74">
          No importa el problema. Importa que tenés razón y no sabés cómo
          hacerla valer.
        </p>

        <div className="space-y-2.5 md:space-y-3" data-id="element-75">
          {audiences.map((item, i) => {
          const Icon = item.icon;
          const isHighlighted = !!item.badge;
          return <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} whileTap={{
            scale: 0.99
          }} whileHover={{
            x: 4
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.06
          }} className={`relative flex items-center gap-3 md:gap-4 bg-white rounded-xl p-3.5 md:p-5 cursor-pointer group transition-all border ${isHighlighted ? 'border-gold border-l-[4px] shadow-md' : 'border-border border-l-[4px] border-l-blue hover:shadow-md'}`} data-id="element-76">
                {/* Icon */}
                <div className={`flex-shrink-0 w-11 h-11 md:w-12 md:h-12 rounded-lg flex items-center justify-center ${isHighlighted ? 'bg-gold/15 text-gold' : 'bg-blue/10 text-blue'}`} data-id="element-77">
                  <Icon size={22} strokeWidth={2} data-id="element-78" />
                </div>

                {/* Text */}
                <div className="flex-1 min-w-0" data-id="element-79">
                  <div className="flex items-center gap-2 flex-wrap mb-0.5" data-id="element-80">
                    <h4 className="text-[14px] md:text-[16px] font-bold text-navy leading-tight" data-id="element-81">
                      {item.title}
                    </h4>
                    {item.badge && <span className="inline-block bg-gold text-navy text-[9px] md:text-[10px] font-extrabold py-0.5 px-2 rounded-full tracking-[0.08em]" data-id="element-82">
                        {item.badge}
                      </span>}
                  </div>
                  <p className="text-[12px] md:text-[13px] text-text-muted leading-snug" data-id="element-83">
                    {item.desc}
                  </p>
                </div>

                <ArrowRight size={16} className={`flex-shrink-0 transition-all group-hover:translate-x-0.5 ${isHighlighted ? 'text-gold' : 'text-blue/40 group-hover:text-blue'}`} data-id="element-84" />
              </motion.div>;
        })}
        </div>

        <p className="text-center mt-6 md:mt-8 text-[13px] md:text-[14px] text-text-muted" data-id="element-85">
          ¿No estás seguro si es para vos? Tenés 7 días de garantía total →
        </p>
      </div>
    </section>;
}